import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Formik, Field } from "formik";
import { DropDown } from "../../ui/DropDown";
import { TimelineTaskInfoSubject } from "../../subjects/TimelineTaskInfoSubject";
import { GetHook } from "../../api/api";
import { USER_URL } from "../../api/urls";
import { parseDropdown } from "../../utils/parseDropdown";
import { TimelineItem } from "./TimelineItem";
import { get } from "../../utils/get";
import moment from "moment";

interface TimelineProps {
  data: any;
  setFilter?: any;
  filter?: any;
  markAsComplete?: any;
  user?: any;
}

export function useSortTasks(data, user) {
  const [tasks, setTasks] = useState<any>([]);

  function days_between(data) {
    let a = moment(moment(get(data, "due_date")).format("DD-MMM-YYYY"));
    let b = moment(moment().format("DD-MMM-YYYY"));
    const days = a.diff(b, "days");
    return days;
  }
 
 
  useEffect(() => {
    const getStatus = (data) =>
      get(data, "owners").filter((owner) => owner.owner_id === get(user, "id"));
      
    if (data) {
      const dueToday = data.filter((task) => {
        const taskStatus = getStatus(task);
        
        return days_between(task) === 0 && taskStatus[0]?.status !== "complete";
      });
      const overdue = data.filter((task) => {
        const taskStatus = getStatus(task);
        return days_between(task) < 0 && taskStatus[0]?.status !== "complete";
      });
      const sortedOverdue = overdue.sort(
        (a, b) => days_between(a) - days_between(b)
      );
      const notDue = data.filter((task) => {
        const taskStatus = getStatus(task);
        return days_between(task) > 0 && taskStatus[0]?.status !== "complete";
      });
      const sortedNotdue = notDue.sort(
        (a, b) => days_between(a) - days_between(b)
      );

      const completedTasks = data.filter((task) => {
        const taskStatus = getStatus(task);
        return taskStatus[0]?.status === "complete";
      });

       
      setTasks([
        ...dueToday,
        ...sortedOverdue,
        ...sortedNotdue,
        ...completedTasks,
      ]);
    }
    return () => {};
  }, [data]);

  return tasks;
}

export const Timeline = ({
  data,
  setFilter,
  filter,
  markAsComplete,
  user,
}: TimelineProps) => {
  const [active, setActive] = useState("");
  const { data: allUsers } = GetHook(`${USER_URL}?limit=1000`);

  const tasks = useSortTasks(data, user);
  useEffect(() => {
    TimelineTaskInfoSubject.next(tasks[0]);
    setActive(tasks[0]?.id);
    return () => {};
  }, [tasks]);

  useEffect(() => {
    setFilter({ ...filter, assigned: get(user, "id") });
    return () => {};
  }, []);

  const parsedUsers = parseDropdown(allUsers);
  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Complete", value: "complete" },
  ];
  return (
    <TImelineContainer>
      <Formik
        initialValues={{
          assigned_to: {
            label: user?.names,
            value: user?.id,
          },
        }}
        onSubmit={() => console.log("object")}
      >
        {({ values, setFieldValue }) => (
          <Filters>
            <Field
              name="assigned_to"
              component={DropDown}
              options={parsedUsers}
              isBordered
              width="95%"
              placeholder="All"
              dropdownLabel="Assigned to"
              onChange={(values) => {
                setFilter({ ...filter, assigned: get(values, "value") });
                setFieldValue("assigned_to", values);
              }}
            />
            <Field
              name="created_by"
              component={DropDown}
              options={parsedUsers}
              placeholder="All"
              isBordered
              width="95%"
              dropdownLabel="Created by"
              onChange={(values) => {
                setFilter({ ...filter, created: get(values, "value") });
              }}
            />
            <Field
              name="status"
              component={DropDown}
              options={statusOptions}
              placeholder="All"
              isBordered
              width="95%"
              dropdownLabel="Status"
              onChange={(values) => {
                setFilter({ ...filter, status: get(values, "value") });
              }}
            />
          </Filters>
        )}
      </Formik>
      <TimelineContent>
        {tasks.map((item) => (
          <TimelineItem
            user={user}
            data={item}
            markAsComplete={markAsComplete}
            active={active}
            setActive={setActive}
          />
        ))}
      </TimelineContent>
    </TImelineContainer>
  );
};

const TImelineContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  grid-row-gap: 2em;
  background-color: #fff;
  border-right: 2px solid #ebeeff;
  padding: 2em 10em 2em 3em;
  border-radius: 10px;
`;
const Filters = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 2em;
`;
const TimelineContent = styled.div`
  height: 70vh;
  overflow: hidden;
  &:hover {
    overflow-y: scroll;
  }
  padding-right: 1em;
`;
